import { DownOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { mapColors } from '../../../../slice/map-constants';

export const Part = styled.div`
  display: flex;
`;

export const CultureDropdownIcon = styled(DownOutlined)<{
  $disabled: boolean;
  $active: boolean;
}>`
  margin: auto 10px auto 0;
  transition: transform 0.3s;
  transform: ${p => (p.$active ? 'rotate(180deg)' : 'unset')};
  opacity: ${p => (p.$disabled ? 0.3 : 1)};
  cursor: ${p => (p.$disabled ? 'default!imporant' : 'pointer !important')};
`;

export const VariationsContainer = styled.div<{ $active: boolean }>`
  max-height: ${p => (p.$active ? '1000px' : '0')};
  opacity: ${p => (p.$active ? 1 : 0)};
  visibility: ${p => (p.$active ? 'visible' : 'hidden')};
  overflow: hidden;
  transition: max-height 0.3s ease-out, opacity 0.3s ease 0.2s;
`;

export const CultureColorCircle = styled.div<{ $color: string | null }>`
  width: 12px;
  height: 12px;
  border-radius: 100%;
  background: ${({ $color = mapColors.colors.DEFAULT }) => $color};
  display: inline-block;
  margin: auto 5px;
`;

export const CheckboxRowAreaPart = styled('div')`
  color: #595959;
  font-size: 12px;
  line-height: 22px;
`;
